import React, { ComponentType, useEffect } from "react";
import {
  Link,
  Route,
  RouteComponentProps,
  RouteProps,
  useHistory
} from "react-router-dom";
import {
  generateReturnToUrl,
  useAuthentication
} from "../context/authentication/AuthenticationProvider";

interface Props extends RouteProps {
  component: ComponentType<RouteComponentProps>;
}

const PrivateRoute: React.FC<Props> = ({
  component: Component,
  ...otherProps
}) => {
  const history = useHistory();
  const { authenticationState, user } = useAuthentication();

  useEffect(() => {
    if (
      !user.email &&
      authenticationState === "authenticated" &&
      history.location.pathname !== "/auth/email/update" &&
      history.location.pathname !== "/auth/email/verify-code"
    ) {
      history.push("/auth/email/update");
    }
  }, [authenticationState, history, user.email]);

  return (
    <Route
      {...otherProps}
      render={(props: RouteComponentProps<{}>) => {
        if (
          (authenticationState === "authenticated" && user.email) ||
          authenticationState === "checking"
        ) {
          return <Component {...props} />;
        }

        return (
          <div className="h-96 flex flex-col justify-center items-center dark:text-white">
            <Link
              to={`/login?${generateReturnToUrl(history.location)}`}
              className="mb-2 inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-hotspotty-400 hover:bg-hotspotty-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-hotspotty-400"
            >
              Sign in
            </Link>
            <p>to unlock this section</p>
          </div>
        );
      }}
    />
  );
};

export default PrivateRoute;
